import { useState } from 'react';
import { parseISO, isValid, format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { Flex, Button, Text } from '@radix-ui/themes';
import DatePicker from '../../../../shared/DatePicker/DatePicker.jsx';
import styles from './SimpleDateForm.module.css';

export default function SimpleDateForm({
  campaignStartDate,
  campaignEndDate,
  onSave,
  onCancel,
}) {
  const { t } = useTranslation('campaigns');

  const formatDateForInput = dateString => {
    if (!dateString) return '';

    const date = parseISO(dateString);
    if (!isValid(date)) return '';

    return format(date, 'yyyy-MM-dd');
  };

  const [startDate, setStartDate] = useState(
    formatDateForInput(campaignStartDate),
  );
  const [endDate, setEndDate] = useState(formatDateForInput(campaignEndDate));
  const [error, setError] = useState('');

  const handleSave = () => {
    // Validate dates
    if (!startDate) {
      setError(t('simpleDateForm.startDateRequired'));
      return;
    }

    if (!endDate) {
      setError(t('simpleDateForm.endDateRequired'));
      return;
    }

    if (new Date(startDate) > new Date(endDate)) {
      setError(t('simpleDateForm.startDateAfterEndDate'));
      return;
    }

    setError('');
    onSave([startDate, endDate]);
  };

  const handleCancel = () => {
    onCancel();
  };

  const handleDateChange = dates => {
    if (dates && dates.length === 2) {
      setStartDate(dates[0]);
      setEndDate(dates[1]);
      setError('');
    }
  };

  return (
    <Flex direction="column" gap="3">
      <div className={styles.calendarWrapper}>
        <DatePicker
          value={[startDate, endDate]}
          onChange={handleDateChange}
          minDate="today"
          mode="range"
          size={1.1}
        />
      </div>

      {error && (
        <Text size="2" className={styles.errorMessage}>
          {error}
        </Text>
      )}

      <Flex gap="3" justify="end">
        <Button variant="outline" size="3" onClick={handleCancel}>
          {t('simpleDateForm.cancel')}
        </Button>
        <Button variant="solid" size="3" onClick={handleSave}>
          {t('simpleDateForm.saveChanges')}
        </Button>
      </Flex>
    </Flex>
  );
}
